// File: src/lib/utils.ts
// CTO Recovery Prompt — shared frontend utilities.
// Minimal shadcn-style helpers, no magic.

export function cn(...inputs: Array<string | undefined | null | false>) {
  return inputs.filter(Boolean).join(" ");
}
